import React from "react";
import HomeUserInside from "../HomeUserInside/HomeUserInside";
import { HomeStyledContainer } from "./HomePageComponent.styled";
import PropTypes from "prop-types";

const HomePageComponent = ({ menuList }) => {
  return (
    <HomeStyledContainer>
      <HomeUserInside menuList={menuList}></HomeUserInside>
    </HomeStyledContainer>
  );
};

export default HomePageComponent;

HomePageComponent.propTypes = {
  menuList: PropTypes.array,
}
